import { RouteInfo } from './sidenav.interface';

export const ROUTES: RouteInfo[] = [
  {
    path: '/main/dashboard',
    title: 'Dashboard',
    position: 1,
    icon: 'grid',
    feather: true,
    class: '',
    submenu: [],
    operator: true,
    fronter: true,
    sales_rep: true,
    sales_manager: true,
    super_admin: true,
    dispatcher: true,
    dispatcher_manager: true,
    track_trace: false,
    account_payable: false,
    account_receivable: false,
    carrier_relations: false,
    data_entry: false,
    quality_assurance: false,
    carrier_sales: false
  },
  {
    path: '/main/leads',
    title: 'Leads',
    position: 2,
    feather: false,
    icon: 'icon_leads',
    class: '',
    submenu: [],
    operator: false,
    fronter: true,
    sales_rep: true,
    sales_manager: true,
    super_admin: true,
    dispatcher: false,
    dispatcher_manager: false,
    track_trace: false,
    account_payable: false,
    account_receivable: false,
    carrier_relations: false,
    data_entry: false,
    quality_assurance: false,
    carrier_sales: false
  },
  {
    path: '/main/quotes',
    title: 'Quotes',
    position: 3,
    icon: 'edit-2',
    feather: true,
    class: '',
    submenu: [],
    operator: true,
    fronter: false,
    sales_rep: true,
    sales_manager: true,
    super_admin: true,
    dispatcher: false,
    dispatcher_manager: false,
    track_trace: false,
    account_payable: false,
    account_receivable: false,
    carrier_relations: false,
    data_entry: false,
    quality_assurance: false,
    carrier_sales: false
  },
  {
    path: '/main/orders',
    title: 'Orders',
    position: 4,
    icon: 'align-left',
    feather: true,
    class: '',
    submenu: [],
    operator: true,
    fronter: false,
    sales_rep: true,
    sales_manager: true,
    super_admin: true,
    dispatcher: true,
    dispatcher_manager: true,
    track_trace: true,
    account_payable: true,
    account_receivable: true,
    carrier_relations: true,
    data_entry: true,
    quality_assurance: true,
    carrier_sales: true
  },
  {
    path: '/main/payments',
    title: 'Payments',
    position: 5,
    icon: 'dollar-sign',
    feather: true,
    class: '',
    submenu: [],
    operator: false,
    fronter: false,
    sales_rep: false,
    sales_manager: false,
    super_admin: true,
    dispatcher: false,
    dispatcher_manager: false,
    track_trace: false,
    account_payable: false,
    account_receivable: false,
    carrier_relations: false,
    data_entry: false,
    quality_assurance: false,
    carrier_sales: false
  },
  {
    path: '/main/companies',
    title: 'Shippers',
    position: 6,
    icon: 'briefcase',
    feather: true,
    class: '',
    submenu: [],
    operator: true,
    fronter: false,
    sales_rep: true,
    sales_manager: true,
    super_admin: true,
    dispatcher: false,
    dispatcher_manager: false,
    track_trace: false,
    account_payable: false,
    account_receivable: true,
    carrier_relations: false,
    data_entry: false,
    quality_assurance: false,
    carrier_sales: false
  },
  {
    path: '/main/carriers',
    title: 'Carriers',
    position: 7,
    icon: 'truck',
    feather: true,
    class: '',
    submenu: [],
    operator: false,
    fronter: false,
    sales_rep: false,
    sales_manager: false,
    super_admin: true,
    dispatcher: true,
    dispatcher_manager: true,
    track_trace: false,
    account_payable: true,
    account_receivable: false,
    carrier_relations: false,
    data_entry: false,
    quality_assurance: false,
    carrier_sales: true
  },
  {
    path: '/main/users',
    title: 'Users',
    position: 8,
    icon: 'users',
    feather: true,
    class: '',
    submenu: [],
    operator: false,
    fronter: false,
    sales_rep: false,
    sales_manager: false,
    super_admin: true,
    dispatcher: false,
    dispatcher_manager: false,
    track_trace: false,
    account_payable: false,
    account_receivable: false,
    carrier_relations: false,
    data_entry: false,
    quality_assurance: false,
    carrier_sales: false
  },
  {
    path: '/main/tiers',
    title: 'Tier List',
    position: 9,
    icon: 'clipboard',
    feather: true,
    class: '',
    submenu: [],
    operator: true,
    fronter: false,
    sales_rep: true,
    sales_manager: true,
    super_admin: true,
    dispatcher: true,
    dispatcher_manager: true,
    track_trace: true,
    account_payable: false,
    account_receivable: true,
    carrier_relations: true,
    data_entry: true,
    quality_assurance: true,
    carrier_sales: false
  }
];
